import SafeSessionStorage from './storage/SafeSessionStorage';

const STORAGE_KEY = 'tab.id';

export default class TabTracking {
	_safeSessionStorage: SafeSessionStorage;

	constructor() {
		this._safeSessionStorage = new SafeSessionStorage();
	}

	getCurrentTabId(): string {
		let tabId = this._safeSessionStorage.getItem(STORAGE_KEY);
		if (!tabId) {
			tabId = this._generateNewTabId();
		}
		return tabId;
	}

	_generateNewTabId = (): `${string}-${string}-${string}-${string}-${string}` => {
		const newTabId = crypto.randomUUID();
		this._safeSessionStorage.setItem(STORAGE_KEY, newTabId);
		return newTabId;
	};
}
